module.exports = __webpack_public_path__ + "img/BackScreens.38dda035.jpg";